import { css } from "@emotion/react"
import { Article } from "component/Article"
import { useDisplayedArticle } from "globalState"
import { ChangeEvent, useState, MouseEvent } from "react"
import { IconContext } from "react-icons"
import {RiImageAddLine, RiListOrdered, RiEditLine} from "react-icons/ri"
import {upload} from "utils/common"
import { NoFileError } from "error"
import { toast } from "react-toastify"
import axios, { AxiosProgressEvent } from "axios"
import { registerArticlePhotosRecord, updateArticleMessage } from "utils/httpApi"
import { AddImage,ChangeOrder, ChangeMessage } from "./component"
import { API_BASE_URL } from "config"

const ADD_IMAGE = 'addImage'
const CHANGE_ORDER = 'changeOrder'
const CHANGE_MESSAGE = 'changeMessage'

export const ArticleEdit = ()=>{
  const [articleWithPhoto,] = useDisplayedArticle()
  const [selectedEditType, setSelectedEditType] = useState<string>('')
  const [displayedProgress, setDisplayedProgress] = useState<number>(0)
  const [buttonText, setButtonText] = useState<string>('アップロード')
  const [selectedList, setSelectedList] = useState<Array<string>>([])

  let inputFiles : FileList | null
  const onChange = (evt: ChangeEvent<HTMLInputElement>) =>{
    inputFiles = evt.target.files
  }

  const onUploadProgress = (event: AxiosProgressEvent) => {
    const currentProgress = event.total? Math.floor((event.loaded * 100) / event.total ) : event.loaded
    setDisplayedProgress(currentProgress)
  }

  let message = ""
  const onMessageChange = (evt: ChangeEvent<HTMLTextAreaElement>)=>{
    message = evt.target.value
  }

  const onUpdateClick = async ()=>{
    try{
      await updateArticleMessage(articleWithPhoto.article.id, message)
      toast.success('message is changed successfully')
    }catch(e){
      toast.error('message change failure')
    }
  }

  const onVideoItemClick = (evt: MouseEvent<HTMLDivElement>, index: number)=>{
    if(!selectedList.includes(articleWithPhoto.photos[index].filename)){
      setSelectedList(()=>[...selectedList, articleWithPhoto.photos[index].filename])
    }else{
      setSelectedList(
        selectedList.filter(v=>v!==articleWithPhoto.photos[index].filename)
      )
    }
  }

  const onImageItemClick = (evt: MouseEvent<HTMLImageElement>, index: number)=>{
    if(!selectedList.includes(articleWithPhoto.photos[index].filename)){
      setSelectedList(()=>[...selectedList, articleWithPhoto.photos[index].filename])
    }else{
      setSelectedList(
        selectedList.filter(v=>v!==articleWithPhoto.photos[index].filename)
      )
    }
  }

  const onChangeOrderButtonClick = async (evt: MouseEvent<HTMLButtonElement>)=>{
    if(selectedList.length !== articleWithPhoto.photos.length){
      toast.error('Please select all items')
      return
    }

    try{
      await axios.put(API_BASE_URL + '/article/order',{
        id: articleWithPhoto.article.id,
        photos: selectedList
      })
      toast.success('Order is changed successfully')
    }catch(e){
      toast.error('Order change failed')
    }
  }
  
  const addImageTabCss= selectedEditType === ADD_IMAGE ? [tabCss, underLineCss] : [tabCss]
  const changeOrderTabCss = selectedEditType === CHANGE_ORDER ? [tabCss, underLineCss] : [tabCss]
  const changeMessageTabCss = selectedEditType === CHANGE_MESSAGE ? [tabCss, underLineCss] : [tabCss]
  
  const onUploadClick = async ()=>{
    try{
      if(inputFiles === null){
        throw new NoFileError('')
      } 

      const filenames = await upload(
          inputFiles, onUploadProgress, 
          i=>setButtonText((i+1) + '/' + inputFiles?.length), 
          ()=>setButtonText('アップロード')
        )
      if (filenames === undefined) throw new Error("")

      await registerArticlePhotosRecord(articleWithPhoto.article.id, filenames)

      toast.success('Upload is successful!')
    }catch(e){
      if(e instanceof NoFileError){
        toast.warn('No file is selected')
      }else{
        toast.error('Upload is failed.')
      }
    }
  }

  return(
    <div css={editPageContainerCss}>
      <Article 
        articleWithPhoto={articleWithPhoto}
        isShowEdit={false}
      />
      <div css={editBarContainerCss}>
        <IconContext.Provider value={{color: "black", size: "2rem"}}>
          <div css={addImageTabCss} onClick={()=>setSelectedEditType(ADD_IMAGE)}><RiImageAddLine/></div>
          <div css={changeOrderTabCss} onClick={()=>setSelectedEditType(CHANGE_ORDER)}><RiListOrdered/></div>
          <div css={changeMessageTabCss} onClick={()=>setSelectedEditType(CHANGE_MESSAGE)}><RiEditLine/></div>
        </IconContext.Provider>
      </div>
      <div css={editAreaContainerCss}>
        {
          (selectedEditType === ADD_IMAGE) ? (
            <AddImage
              onChange={onChange}
              buttonText={buttonText}
              onUploadClick={onUploadClick}
              progress={displayedProgress}
            />
          ) : (selectedEditType === CHANGE_ORDER) ?(
            <ChangeOrder
              article={articleWithPhoto}
              selectedList={selectedList}
              onPhotoClick={onImageItemClick}
              onVideClick={onVideoItemClick}
              onButtonClick={onChangeOrderButtonClick}
            />
          ) : (selectedEditType === CHANGE_MESSAGE) ?(
            <ChangeMessage
              onChange={onMessageChange}
              onUpdateClick={onUpdateClick}
            />
          ) : (
            <></>
          )
        }
      </div>
    </div>
  )
}

const editPageContainerCss = css`
`

const editBarContainerCss = css`
  display: flex;
  justify-content: space-between;
  height: 5rem;
`
const tabCss = css`
  padding: 15px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 0 0 3px 0;
  border-style: solid;
  border-color: transparent;
`

const underLineCss=css`
  border-color: black;
`

const editAreaContainerCss = css`
`